<edl-modal-details
    [title]="'User Cycle Details'"
    [isReadOnly]="isReadOnly"
    [navigationSections]="navigationSections"
    [startingNavigationItemId]="startingNavigationItemId"
></edl-modal-details>
